import { html, rune, View } from 'rune-ts';
import klass from './CaseSection.module.scss';
import { staticTypo, typoPcMo } from '../../../../../shared/typography/typo';
import { getResizedUrl } from '../../../../../shared/util/image';

interface CaseCardProps {
  caseLabel: 'a' | 'b' | 'c' | 'd' | 'e';
}
export class CaseCard extends View<CaseCardProps> {
  override template() {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;
    const { caseLabel } = this.data;
    const texts = {
      case_transaction: ET('mps2::landing::popup_store::case_transaction'),
      case_ordered: ET('mps2::landing::popup_store::case_ordered'),
      case_duration: ET('mps2::landing::popup_store::case_duration'),
      transaction: ET(`mps2::landing::popup_store::case_transaction_${caseLabel}`),
      ordered: ET(`mps2::landing::popup_store::case_ordered_${caseLabel}`),
      duration: ET(`mps2::landing::popup_store::case_duration_${caseLabel}`),
    };
    const title_typo = is_mobile ? staticTypo('bebas_24_bold') : staticTypo('bebas_40_bold');

    return html`
      <div class="${klass.case_card}">
        <div class="${klass.image}">
          <div class="${klass.image_backdrop} ${title_typo}">CASE ${caseLabel}</div>
        </div>

        <div class="${klass.row}">
          <div class="${klass.field} ${typoPcMo({ is_mobile, pc: '20_bold', mo: '14_bold' })}">
            ${texts.case_transaction}
          </div>
          <div class="${klass.value} ${typoPcMo({ is_mobile, pc: '20_bold', mo: '14_bold' })}">
            ${texts.transaction}
          </div>
        </div>
        <div class="${klass.row}">
          <div class="${klass.field} ${typoPcMo({ is_mobile, pc: '20_bold', mo: '14_bold' })}">
            ${texts.case_ordered}
          </div>
          <div class="${klass.value} ${typoPcMo({ is_mobile, pc: '20_bold', mo: '14_bold' })}">
            ${texts.ordered}
          </div>
        </div>
        <div class="${klass.row}">
          <div class="${klass.field} ${typoPcMo({ is_mobile, pc: '20_bold', mo: '14_bold' })}">
            ${texts.case_duration}
          </div>
          <div class="${klass.value} ${typoPcMo({ is_mobile, pc: '20_bold', mo: '14_bold' })}">
            ${texts.duration}
          </div>
        </div>
      </div>
    `;
  }

  override onRender() {
    const { caseLabel } = this.data;
    const element = this.element().querySelector(`.${klass.image}`) as HTMLElement;
    element.style.background = `url("${getResizedUrl({
      url: `//s3.marpple.co/files/u_14345/2024/6/original/case-${caseLabel}.png`,
      width: 1920 * 2,
      format: 'webp',
      quality: 85,
    })}") lightgray 50% / cover no-repeat`;
  }
}
